import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import 'moment/locale/fr';
import React from 'react';

const css = {
  title: {
    marginLeft: '25px',
    marginRight: '25px',
  }
}

const MyDialog = (props) => {
  const {open, handleClose, title, content, dialog, hideCloseBtn, falseButtonLabel, trueButtonLabel} = props;

  const handleReturn = (value) => {
    if (dialog) {
      dialog(value);
    }
    handleClose(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        {title && <DialogTitle style={css.title}>{title}</DialogTitle>}
        <DialogContent dividers>
          <div className="dialog-content">{content}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleReturn(false)} color="primary" style={hideCloseBtn && {display: 'none'}}> {falseButtonLabel ?? 'Annuler'} </Button>
          <Button onClick={() => handleReturn(true)} color="primary"> {trueButtonLabel ?? 'Valider'} </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MyDialog;